<yo-generic-datagrid-pn [pathFileHelp]="pathFile" [service]="declinaisonsService"></yo-generic-datagrid-pn>
